/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";

/**
 *
 * @export
 * @interface RequiredAgreementsDTO
 */
export interface RequiredAgreementsDTOOptional {
  /**
   *
   * @type {Array<AgreementRef>}
   * @memberof RequiredAgreementsDTO
   */
  requiredAgreements?: AgreementRefOptional[];
}

export interface RequiredAgreementsDTO extends RequiredAgreementsDTOOptional {
  /**
   *
   * @type {Array<AgreementRef>}
   * @memberof RequiredAgreementsDTO
   */
  requiredAgreements?: AgreementRef[];
}

export interface RequiredAgreementsDTOTrackedI {
  /**
   *
   * @type {Array<AgreementRef>}
   * @memberof RequiredAgreementsDTO
   */
  requiredAgreements?: AgreementRefTrackedI[];
  requiredAgreementsIsSet: boolean;
}

transformDatesMap.set(
  "RequiredAgreementsDTO",
  function (model: RequiredAgreementsDTO) {
    const transformDatesrequiredAgreements =
      transformDatesMap.get("AgreementRef");
    if (transformDatesrequiredAgreements) {
      model.requiredAgreements?.forEach((sub) => {
        transformDatesrequiredAgreements(sub);
      });
    }
  },
);

export type RequiredAgreementsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  requiredAgreements: PropertyMeta<AgreementRefMetaI>;
}>;

export var RequiredAgreementsDTOMeta: RequiredAgreementsDTOMetaI =
  {} as RequiredAgreementsDTOMetaI;
RequiredAgreementsDTOMeta = typeMeta("RequiredAgreementsDTO", {
  requiredAgreements: propertyMeta(
    "requiredAgreements",
    true,
    false,
    false,
    AgreementRefMeta,
  ),
});

const metaI = RequiredAgreementsDTOMeta;

registerMeta(() => {});

export class RequiredAgreementsDTOTracked implements RequiredAgreementsDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  requiredAgreements__I?: AgreementRefTracked[] = undefined;
  requiredAgreementsIsSet: boolean = false;
  set requiredAgreements(v: undefined | AgreementRefTracked[]) {
    if (v !== undefined) {
      this.requiredAgreements__I = v;
      this.requiredAgreementsIsSet = true;
    } else {
      this.requiredAgreements__I = v || undefined;
      this.requiredAgreementsIsSet = false;
    }
    this.changeTracker = true;
  }
  get requiredAgreements() {
    return this.requiredAgreements__I;
  }
  constructor(config?: RequiredAgreementsDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.requiredAgreements?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: RequiredAgreementsDTOOptional,
    options?: AssignOptions,
  ): RequiredAgreementsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.requiredAgreements &&
      this.requiredAgreementsApplyFilter(optionsRequired.filter)
    ) {
      this.requiredAgreements = config.requiredAgreements?.map(
        (a) => new AgreementRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.requiredAgreementsIsSet = false;
      else this.requiredAgreementsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): RequiredAgreementsDTOTrackedI {
    const cloned = {} as RequiredAgreementsDTOTrackedI;
    if (
      this.requiredAgreementsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.requiredAgreementsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.requiredAgreementsIsSet = true;
      cloned.requiredAgreements = this.requiredAgreements
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.requiredAgreementsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): RequiredAgreementsDTOTrackedI {
    if (!this.requiredAgreementsApplyFilter(filter))
      this.requiredAgreementsIsSet = false;

    this.requiredAgreements?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  requiredAgreementsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RequiredAgreementsDTOMeta.requiredAgreements,
      RequiredAgreementsDTOMeta,
      this.requiredAgreements,
      this,
    );
  }
  requiredAgreementsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.requiredAgreementsIsSet &&
      this.requiredAgreementsApplyFilter(filter)
    )
      return true;

    return this.requiredAgreements?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.requiredAgreementsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
